import React, { Fragment } from 'react'
import SubsCheckout from '../../Components/Subscription/SubsCheckout'
import TopBanner from '../../Components/Main/TopBanner'

const SubscriptionCheckout = () => {
    return (
        <Fragment>
            <TopBanner title={"Checkout"} />
            <SubsCheckout />
        </Fragment>
    )
}

export default SubscriptionCheckout